import { parseAsString, useQueryState } from 'nuqs';
import { useContext, useState } from 'react';

import { StaticTextContext } from '@/components/context/StaticTextProvider';

export const useLanguage = (languages) => {
  const { st } = useContext(StaticTextContext);

  const [language, setLanguage] = useQueryState(
    st('language.key'),
    parseAsString.withDefault(''),
  );

  const [selectedLanguage, setSelectedLanguage] = useState(
    languages.find((l) => l.slug === (language === '' ? null : language)),
  );

  const onLanguageChange = (currentLanguage) => {
    setSelectedLanguage(currentLanguage);
    setLanguage(currentLanguage.id);
  };

  return { selectedLanguage, onLanguageChange };
};
